export const phpBackendApiValidator = (status: number): boolean => {
    if (status >= 200 && status < 400) return true;
    return false;
};

export const goBackendApiValidator = (status: number): boolean => {
    if (status >= 200 && status < 400) return true;
    return false;
};
